module.exports = __webpack_public_path__ + "img/vip_set_icon.f2c58781.svg";